import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DiscussionIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-discussion-empty-state',
  imports: [TranslocoPipe, DiscussionIconComponent],
  templateUrl: './discussion-empty-state.component.html',
  styleUrl: './discussion-empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DiscussionEmptyStateComponent {}
